export enum settings {
    size,
    opacity,
    color,
}
